export const SALES_QUOTES_RESET_STATE = 'SALES_QUOTES_RESET_STATE';
export const SALES_QUOTES_CURRENT_ITEM = 'SALES_QUOTES_CURRENT_ITEM';

export const SALES_QUOTES_REQUEST_LOADING = 'SALES_QUOTES_REQUEST_LOADING';
export const SALES_QUOTES_REQUEST_SUCCESS = 'SALES_QUOTES_REQUEST_SUCCESS';
export const SALES_QUOTES_REQUEST_FAILED = 'SALES_QUOTES_REQUEST_FAILED';

export const SALES_QUOTES_CURRENT_ACTION = 'SALES_QUOTES_CURRENT_ACTION';
export const SALES_QUOTES_RESET_ACTION = 'SALES_QUOTES_RESET_ACTION';
